import { LINKS, LOCATION_QUERY } from '@trip-ux/constants';
import axios from 'axios';
import { get } from 'lodash';
import { prepareHeaders } from '../api.client';
import { ReduxStore } from '../payload-types';
import { fork, select, call, take, put } from 'redux-saga/effects';
import {
  TRAVEL_DEPARTURE_SEARCH,
  TRAVEL_DEPARTURE_SEARCH_RESULT,
  TRAVEL_DESTINATIONS_SEARCH,
  TRAVEL_DESTINATIONS_SEARCH_RESULT
} from './types';
import { KEEP_ALIVE_SUCCESS } from '../idle';
import { time } from 'uniqid';

const getLocationList = (state: ReduxStore, payload) =>
  axios
    .post(
      `${get(state, 'config.options.contextPath', '')}${LINKS.GRAPHQL}`,
      {
        query: LOCATION_QUERY,
        variables: payload
      },
      {
        headers: Object.fromEntries(
          Object.entries(prepareHeaders(state)).map(([k, v]) => [k, String(v)])
        )
      }
    )
    .then(res => get(res, 'data.data.distinctTravelLocations', []))
    .catch(() => []);

function* watchDestinationSearchRequest() {
  while (true) {
    const { payload } = yield take(TRAVEL_DESTINATIONS_SEARCH);
    const state: ReduxStore = yield select((store: ReduxStore) => store);
    yield put({ type: KEEP_ALIVE_SUCCESS, payload: time('') });
    const locations = yield call(getLocationList, state, payload);
    yield put({ type: TRAVEL_DESTINATIONS_SEARCH_RESULT, payload: locations });
  }
}

function* watchDepartureSearchRequest() {
  while (true) {
    const { payload } = yield take(TRAVEL_DEPARTURE_SEARCH);
    const state: ReduxStore = yield select((store: ReduxStore) => store);
    yield put({ type: KEEP_ALIVE_SUCCESS, payload: time('') });
    const locations = yield call(getLocationList, state, payload);
    yield put({ type: TRAVEL_DEPARTURE_SEARCH_RESULT, payload: locations });
  }
}

export default [fork(watchDestinationSearchRequest), fork(watchDepartureSearchRequest)];
